import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { formatNumberWithCommas } from 'helper';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import _ from 'lodash';
import * as actions from '../action';
import * as c from '../constant';
import ViewTaxableReasonModal from '../modals/ViewTaxableReasonModal';
import ReasonModal from '../modals/ReasonModal';


function PropertyAssessmentContainer({
  getList,
  propertyAssessmentList,
  applicationId,
  isLoading,
  totalAppraisedValue,
  totalAssessmentLevel,
  totalAssessedValue,
  totalDepreciation,
  totalMarketValue,
  totalArea,
  updateBuildingPropertyAssessment,
  type,
  applicationStatus,
  permissions,
}) {

  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    getList(applicationId);
  }, []);

  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    getList(applicationId);

  }, [applicationId]);

  const setModal = useContext(ModalContext);

  const handleChange = (e, id, data) => {
    const val =
      e.target.type === 'checkbox' ? e.target.checked : e.target.value;

    if (val === true) {
      const args = {
        ...data.attributes,
        taxability: 1,
        reason: '',
      };
      updateBuildingPropertyAssessment(id, data.id, args, () => {
        getList(id)
      });
    } else {
      setModal({
        isOpen: true,
        content: (
          <ReasonModal
            id={data.id}
            applicationId={id}
            updateList={data.attributes}
          />
        ),
        title: 'Add Exemption Reason',
        modalSize: 'modal-md',
      });
    }
  };

  const handleView = (dataInfo) => (e) => {
    e.preventDefault();
    setModal({
      title: 'View Exemption Reason',
      isOpen: true,
      content: <ViewTaxableReasonModal taxableReason={dataInfo} />,
      modalSize: 'modal-lg',
    });
  };

  return (

    <div className="card p-0 mr-2">
      {isLoading ? (
        <div className="loading">
          <div className="spinner text-center">
            <span className="fas fa-1x fa-spin fa-spinner" />
          </div>
        </div>
      ) : (
        <>
          <div className="table-div">
            <div className="table-assessment row my-3 mx-2">
              <table className="table table-borderless">
                <thead className="table-header">
                  <tr className="cms-bg-color-primary-light cms-text-primary">
                    <td className="fixed-col font-weight-bold cms-bg-color-primary-light cms-text-primary">Actual Use</td>
                    <td className="font-weight-bold cms-bg-color-primary-light cms-text-primary">Area</td>
                    {Acl(permissions, ['E2E RPT BUILDING PROPERTY ASSESSMENT DETAILS']) &&
                      (
                        <>
                          <td className="font-weight-bold cms-bg-color-primary-light cms-text-primary">Appraised Value</td>
                          <td className="font-weight-bold cms-bg-color-primary-light cms-text-primary">Depreciation</td>
                          <td className="font-weight-bold cms-bg-color-primary-light cms-text-primary">Market Value</td>
                        </>
                      )}
                    <td className="font-weight-bold cms-bg-color-primary-light cms-text-primary">Assessment Level</td>
                    <td className="font-weight-bold cms-bg-color-primary-light cms-text-primary">Assessed Value</td>
                    <td className="font-weight-bold cms-bg-color-primary-light cms-text-primary">Taxability</td>
                    <td className="font-weight-bold cms-bg-color-primary-light cms-text-primary">Tax Exempt Code</td>
                    <td className="font-weight-bold cms-bg-color-primary-light cms-text-primary">Exemption Reason</td>
                  </tr>
                </thead>
                <tbody>
                  {propertyAssessmentList &&
                    propertyAssessmentList.length <= 0 && (
                      <tr className="text-center">
                        <td className="history-color" colSpan="7">No data</td>
                      </tr>
                    )}
                  {propertyAssessmentList &&
                    propertyAssessmentList.map(item => (
                      <tr key={item.id}>
                        <td className="fixed-col history-color">{formatNumberWithCommas(_.get(item, 'attributes.actual_use'))}</td>
                        <td className="history-color">{formatNumberWithCommas(_.get(item, 'attributes.area'))}</td>
                        {Acl(permissions, ['E2E RPT BUILDING PROPERTY ASSESSMENT DETAILS']) &&
                          (
                            <>
                              <td className="history-color">{formatNumberWithCommas(_.get(item, 'attributes.appraised_value'))}</td>
                              <td className="history-color">{formatNumberWithCommas(_.get(item, 'attributes.depreciation'))}</td>
                              <td className="history-color">{formatNumberWithCommas(_.get(item, 'attributes.market_value'))}</td>
                            </>
                          )}
                        <td className="history-color">{formatNumberWithCommas(_.get(item, 'attributes.assessment_level'))}</td>
                        <td className="history-color">{formatNumberWithCommas(_.get(item, 'attributes.assessed_value'))}</td>
                        <td className="text-center">
                          <input
                            name="taxability"
                            type="checkbox"
                            checked={_.get(item, 'attributes.taxability')}
                            disabled={
                              type === 'history' ||
                              applicationStatus === 'CANCELLED'
                            }
                            onChange={(e) =>
                              handleChange(e, applicationId, item)
                            }
                          />
                        </td>
                        <td>
                          <span style={{ color: '#65676b' }}>
                            {_.get(item, 'attributes.tax_exempt_code')}
                          </span>
                        </td>
                        {_.get(item, 'attributes.taxability') === 0 && (
                          <td className="text-center">
                            <button
                              type="button"
                              onClick={handleView(
                                _.get(item, 'attributes.reason')
                              )}
                              className="btn-blank button-eye"
                            >
                              <i className="far fa-eye icon-view" />
                            </button>
                          </td>
                        )}
                      </tr>
                    ))}
                  <tr>
                    <td className="fixed-col history-color"><span className="font-weight-bold">Total</span></td>
                    <td className="history-color bg-white"><span className="font-weight-bold">{totalArea || '--'}</span></td>
                    {Acl(permissions, ['E2E RPT BUILDING PROPERTY ASSESSMENT DETAILS']) &&
                      (
                        <>
                          <td className="history-color bg-white"><span className="font-weight-bold">{totalAppraisedValue || '--'}</span></td>
                          <td className="history-color bg-white"><span className="font-weight-bold">{totalDepreciation || '--'}</span></td>
                          <td className="history-color bg-white"><span className="font-weight-bold">{totalMarketValue || '--'}</span></td>
                        </>
                      )}
                    <td className="history-color bg-white"><span className="font-weight-bold">{totalAssessmentLevel || '--'}</span></td>
                    <td className="history-color bg-white"><span className="font-weight-bold">{totalAssessedValue || '--'}</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

PropertyAssessmentContainer.defaultProps = {
  applicationId: '',
  type: '',
  applicationStatus: '',
};

PropertyAssessmentContainer.propTypes = {
  getList: PropTypes.instanceOf(Function).isRequired,
  propertyAssessmentList: PropTypes.instanceOf(Array).isRequired,
  applicationId: PropTypes.string,
  type: PropTypes.string,
  applicationStatus: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  totalAppraisedValue: PropTypes.string.isRequired,
  totalAssessmentLevel: PropTypes.string.isRequired,
  totalAssessedValue: PropTypes.string.isRequired,
  totalDepreciation: PropTypes.string.isRequired,
  totalMarketValue: PropTypes.string.isRequired,
  permissions: PropTypes.instanceOf(Array).isRequired,
  totalArea: PropTypes.string.isRequired,
  updateBuildingPropertyAssessment: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  totalAppraisedValue: _.get(api, `${c.GET_ASSESSMENT_LIST}.res.total_appraised_value`) || '--',
  totalArea: _.get(api, `${c.GET_ASSESSMENT_LIST}.res.total_area`) || '--',
  totalAssessedValue: _.get(api, `${c.GET_ASSESSMENT_LIST}.res.total_assessed_value`) || '--',
  totalAssessmentLevel: _.get(api, `${c.GET_ASSESSMENT_LIST}.res.total_assessment_level`) || '--',
  totalDepreciation: _.get(api, `${c.GET_ASSESSMENT_LIST}.res.total_depreciation`) || '--',
  totalMarketValue: _.get(api, `${c.GET_ASSESSMENT_LIST}.res.total_market_value`) || '--',
  propertyAssessmentList: _.get(api, `${c.GET_ASSESSMENT_LIST}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_ASSESSMENT_LIST) > -1,
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(PropertyAssessmentContainer);
